var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminPoliciesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 58645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Policies Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 58306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction 1",
    d: "M33.2453 43.1824H12.9455C12.4243 43.1953 11.9061 43.1018 11.4223 42.9076C10.9384 42.7135 10.4993 42.4228 10.1315 42.0533C9.76173 41.6855 9.47063 41.2462 9.27633 40.7621C9.08202 40.2781 8.98862 39.7596 9.00141 39.2382V12.9446C8.98726 12.423 9.07957 11.9039 9.27283 11.4192C9.46609 10.9345 9.75634 10.4942 10.1255 10.1254C10.4943 9.75621 10.9345 9.46609 11.4193 9.27283C11.904 9.07957 12.4229 8.98721 12.9445 9.00142H39.237C39.7582 8.98858 40.2764 9.08208 40.7602 9.27621C41.2441 9.47034 41.6837 9.76103 42.0515 10.1305C42.421 10.4983 42.7115 10.9375 42.9057 11.4214C43.0998 11.9052 43.1934 12.4235 43.1806 12.9446V25.3506H40.7393V12.9446C40.7349 12.7498 40.6909 12.5578 40.6101 12.3804C40.5293 12.203 40.4134 12.0438 40.2693 11.9126C40.1377 11.7687 39.9783 11.6528 39.8008 11.5721C39.6233 11.4913 39.431 11.4472 39.236 11.4426H12.9435C12.7484 11.4472 12.5564 11.4912 12.3787 11.572C12.201 11.6528 12.0415 11.7686 11.9097 11.9126C11.766 12.0441 11.6504 12.2033 11.5699 12.3807C11.4895 12.5581 11.4459 12.7499 11.4417 12.9446V39.2382C11.4463 39.4329 11.49 39.6246 11.5704 39.8019C11.6509 39.9793 11.7663 40.1385 11.9097 40.2702C12.0415 40.4142 12.201 40.53 12.3787 40.6108C12.5564 40.6916 12.7484 40.7356 12.9435 40.7403H33.2433V43.1814L33.2453 43.1824ZM31.7544 31.3998H17.5512V28.9586H31.7544V31.3988V31.3998ZM36.6824 25.0962H17.5477V22.656H36.6824V25.0962ZM31.1547 18.5504H17.5477V15.8476H31.1547V18.5493V18.5504Z",
    fill: "#1447B2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.4286 45V38.5714H30V36.4286H36.4286V30H38.5714V36.4286H45V38.5714H38.5714V45H36.4286Z",
    fill: "#1447B2",
    stroke: "#1447B2",
    strokeWidth: 0.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPoliciesIcon);
export default __webpack_public_path__ + "static/media/admin_policies_icon.d93b0c70b524e00d72f1f93369b9b348.svg";
export { ForwardRef as ReactComponent };